'use client'
import { TitleDivider } from 'components/TitleDivider'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'

export default function ValuePropsHeader({ title, eyebrow, subtitle, idContent }) {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  const isMobile = useViewportSmallerThan(BREAKPOINTS.xl)

  return (
    <div className="text-center">
      <TitleDivider
        data-testid={`value-prop-2-title-divider-${idContent}`}
        eyebrow={eyebrow}
        eyebrowBlack
        className={'[*>&]:p-0 [&_h2]:in-[container-grid]:in-[section-breakline]:p-0'}
        classNameTitleText="headingMd lg:displayLg"
        classNameSubtitleText={
          siteEnv === SITE_ENVIRONMENTS.FDR
            ? `bodySm lg:bodyLg font-light!`
            : `bodySm lg:displaySm font-light!`
        }
        title={title}
        subtitle={subtitle}
        isMobile={isMobile}
        disableTitleTag={true}
        disableSubtitleTag={true}
        siteEnv={siteEnv}
      />
    </div>
  )
}
